import { render, staticRenderFns } from "./ss-footer.vue?vue&type=template&id=1e720eba&scoped=true&"
import script from "./ss-footer.vue?vue&type=script&lang=js&"
export * from "./ss-footer.vue?vue&type=script&lang=js&"
import style0 from "./ss-footer.vue?vue&type=style&index=0&id=1e720eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e720eba",
  null
  
)

export default component.exports